<div class="reset-screen">
  <div class="resend">
    <div class="header-container">
      <svg-icon class="header-icon" src="/assets/icons/question-filled-circle.svg"></svg-icon>
    </div>
    <h1 class="main-title">Didn't Receive a Code?</h1>
    <p>If you don’t receive an email with your access code after a few minutes, here are a few things you can try.</p>

    <ul>
      <li>Check your email address for typo</li>
      <li>Check your spam folder</li>
      <li>Make sure you’re looking in the right email account (e.g. work/personal)</li>
    </ul>

    <p>
      If you already have a Kumanu account with that email address,
      <a href="/login">sign in</a>
      instead.
    </p>

    <p>
      If you’re still having trouble, email us at
      <a
        href="mailto:support@kumanu.com?Subject={{ productName }}%20Support%20Request%20-%20Password%20Reset"
        target="_blank">
        support@kumanu.com
      </a>
      .
    </p>

    <div class="button-wrap">
      <button class="button button-pill" (click)="resend()">Resend Code</button>
    </div>
  </div>
</div>
